module.exports = __webpack_public_path__ + "static/media/max3d_plus.8c71bb85.png";